export default "__VITE_ASSET__hrXr71Mv__"